import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TS_EditableItemComponent } from '@nu-art/thunderstorm-frontend/components/TS_EditableItemComponent/TS_EditableItemComponent';
import { TS_Card } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '@app/styles';
import { compare, exists } from '@nu-art/ts-common';
import { ModuleFE_Value } from '../../../../../../../_entity/value/index.js';
import { Editor_TimeRange } from '../time-range-editor/index.js';
export class Component_TimeRangeValueEditor extends TS_EditableItemComponent {
    //FIXME: this is a real hack, there's no way to show validation results in this case cause the save is nested inside the
    // UI variable save..
    componentDidUpdate() {
        try {
            // don't validate
            if (!this.state.editable.item.data?.timeRange.some(value => exists(value)))
                return;
            ModuleFE_Value.validateImpl(this.state.editable.item);
            // @ts-ignore
            this.state.editable.validationResults = undefined;
        }
        catch (err) {
            // @ts-ignore
            if (!compare(this.state.editable.validationResults?.results ?? {}, err.result)) {
                // @ts-ignore
                this.state.editable.validationResults = {
                    autoSave: false,
                    editing: !!this.state.editable.item._id,
                    results: err.result
                };
                this.forceUpdate();
            }
        }
    }
    renderBody = () => {
        const editableTimeRangeData = this.state.editable.editProp('data', {});
        const editableTimeRangeValue = editableTimeRangeData.editProp('timeRange', []);
        return _jsx(Editor_TimeRange, { editable: editableTimeRangeValue });
    };
    render() {
        return _jsxs(TS_Card, { children: [this.renderBody(), exists(this.props.deleteItem) && _jsx(ICONS.x.component, { onClick: this.props.deleteItem })] });
    }
}
//# sourceMappingURL=Component_TimeRangeValueEditor.js.map